<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent width="50%">
      <v-card>
        <v-card-title>
          <span class="headline">Disciplinas do Itinerário Formativo</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-form ref="form">
            <v-layout wrap>
              <v-flex xs12 sm6 md9>
                <v-text-field v-model="nomeCurso" disabled
                  label="Nome do Curso"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md9>
                <v-text-field v-model="itinerarioFormativo.nome" disabled
                  label="Nome"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-text-field v-model="itinerarioFormativo.sigla" disabled
                  label="Sigla"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-select v-model="idPeriodo" item-text="sigla" item-value="id" :items="periodos" label="Período"></v-select>
            </v-flex>
            <v-flex xs12 sm6 md6 v-if="idPeriodo">
                <v-select v-model="idDisciplina" item-text="nome" item-value="id" :items="disciplinasUnificadas" label="Disciplinas" ></v-select>
            </v-flex>
            <v-flex xs12 sm6 md3 v-if="idDisciplina">
              <v-btn color="primary" type="submit" @click.native="adicionarDisciplinaItinerarioFormativo" dark>Incluir</v-btn>
            </v-flex>

          <v-flex xs12 sm2 md12>
            <v-data-table :loading="loading" :headers="headers" :items="disciplinas" class="elevation-1" :total-items="pagination.totalItems" :pagination.sync="pagination">
              <template slot="items" slot-scope="props">
                <td>{{ props.item.siglaPeriodo }}</td>
                <td>{{ props.item.nome }}</td>
                <td>{{ props.item.ativo | booleanFilter }}</td>
                <td>
                          <v-icon medium class="mr-2" @click="excluirDisciplinaItinerarioFormativo(props.item)">
                            delete
                          </v-icon>
                </td>
              </template>
              <template slot="no-data">
                Não existem informações cadastradas!
              </template>
            </v-data-table>
        </v-flex>

            </v-layout>
           
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark @click.native="dialog = false">Cancelar</v-btn>
         
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
//import disciplinaService from "@/service/disciplina/DisciplinaService";
//import DisciplinaPreRequisito from "@/model/disciplina/pre-requisito/DisciplinaPreRequisito";
//import { required } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
import messageMixin from "@/mixins/message";
import EventBus from "@/utils/EventBus";
import periodoService from "@/service/curso/PeriodoService";
import disciplinaService from "@/service/disciplina/DisciplinaService";
import Pagination from "@/utils/Pagination.js";
import Disciplina from "@/model/disciplina/Disciplina";

export default {
  name: "ModalCadastroDisciplinaItinerarioFormativo",
  mixins: [validationMixin, messageMixin],
  // validations: {
  //   disciplinaPreRequisito: DisciplinaPreRequisito.validations(required)
  // },
  // validationMessages: {
  //   disciplinaPreRequisito: DisciplinaPreRequisito.validationMessages()
  // },
  data() {
    return {
      loading: false,
      btnTitle: "",
      dialog: false,
      formTitle: "",
      idCurso: 0,
      idPeriodo: 0,
      periodos: [],
      nomeCurso: "",
      itinerarioFormativo: {},
      disciplinas: [],
      disciplina: new Disciplina(),
      disciplinasUnificadas: [],
      idDisciplina: null,
      pagination: new Pagination(1, 5),
      headers: [
      {
          text: "Sigla Período",
          align: "left",
          sortable: false,
          value: "siglaPeriodo"
        },
        {
          text: "Nome",
          align: "left",
          sortable: false,
          value: "nome"
        },
        {
          text: "Ativo",
          align: "left",
          sortable: false,
          value: "ativo"
        },
        { text: "", value: "name", sortable: false }
      ]
    };
  },
  watch: {
    async idPeriodo() {
      await this.atualizarComboDisciplina();
    },
    pagination: {
      handler() {
        this.pesquisar();
      }
    },
    dialog(val) {
      val || this.close();
    }
  },
  async created() {
    EventBus.$on("abrirCadastroDisciplinaItinerarioFormativo", async (idCurso, nomeCurso, itinerarioFormativo) => {
      this.idCurso = idCurso;
      this.nomeCurso = nomeCurso;
      this.itinerarioFormativo = itinerarioFormativo;
      this.idPeriodo = null;
      this.idDisciplina = null;
      this.carregarDadosBasicos();
      this.pesquisar();
      this.dialog = true;
    });
  },
  methods: {
    adicionarDisciplinaItinerarioFormativo() {
      this.disciplina.idItinerarioFormativo = this.itinerarioFormativo.id;
      disciplinaService.adicionarDisciplinaItinerarioFormativo(this.idDisciplina, this.disciplina).then(() => {
        this.dialog = true;
        this.atualizar();
        this.atualizarComboDisciplina();
        });
    },
    excluirDisciplinaItinerarioFormativo(disciplina) {
      disciplina.idItinerarioFormativo = null;
      confirm("Você deseja realmente excluir remover a disciplina do itinerário formativo?") && disciplinaService.excluirDisciplinaItinerarioFormativo(disciplina.id, disciplina).then(() => {
        this.dialog = true;
        this.atualizar();
        this.atualizarComboDisciplina();
        });
    },
    async carregarDadosBasicos() {
      this.periodos = await periodoService.combo(this.idCurso);
    },
    atualizar() {
      this.pesquisar();
    },
    async pesquisar() {
      if (this.itinerarioFormativo.id) {
        this.loading = true;
        const paginacaoResultado = await disciplinaService.listarDisciplinasItinerariosFormativos(
          this.itinerarioFormativo.id,
          this.pagination.page,
          this.pagination.rowsPerPage
        );
        this.disciplinas = paginacaoResultado.dados;
        this.pagination.totalItems = paginacaoResultado.total;
        this.loading = false;
      }
    },
    async atualizarComboDisciplina() {
      if(this.idPeriodo) {
        this.disciplinasUnificadas = await disciplinaService.comboUnificacoesItinerarioFormaTivo(this.idPeriodo);
      }
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.$v.$reset();
      }, 300);
    }
  }
};
</script>
